import React from 'react'
import { useIntl } from 'react-intl'
import { useConfig } from 'msp-integrations'
import { Icons } from '../../../index'

const CartTopLabels = () => {
  const { formatMessage } = useIntl()
  const {
    theme: { font }
  } = useConfig()

  return (
    <div className='checkout-left flex w-full flex-row items-center justify-center space-x-5 pt-4 xl:justify-end'>
      <span
        className={`${font.wide} text-12 leading-24 tracking-4 uppercase text-white`}
      >
        {formatMessage({
          id: 'msp.cart.top.info.questions',
          defaultMessage: 'Do you have any questions?'
        })}
      </span>
      <span
        className={`${font.wide} text-12 leading-24 tracking-4 uppercase text-white`}
      >
        {formatMessage({
          id: 'msp.cart.top.info.telephone',
          defaultMessage: 'Tel.: 00800 7000 6000'
        })}
      </span>
      <div>
        <span
          className={`${font.wide} text-12 leading-24 tracking-4 uppercase text-white`}
        >
          {formatMessage({
            id: 'msp.cart.top.info.chat',
            defaultMessage: 'Chat:'
          })}
        </span>
        <span className='ml-2'>
          <Icons iconName='Chat' height='22px' width='22px' color='white' />
        </span>
      </div>
    </div>
  )
}

export default CartTopLabels
